import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CompanyService } from '@company/feature';
import { RouterState, RoutingService } from '@spartacus/core';
import { HamburgerMenuService } from '@spartacus/storefront';
import { CurrentProfile } from '@user/const';
import { LoginService } from '@user/data-access';
import { CurrentProfileService } from '@user/feature';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'sd-desktop-login-button',
  templateUrl: './desktop-login-button.component.html',
  styleUrls: ['./desktop-login-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DesktopLoginButtonComponent implements OnInit {
  currentProfile$: Observable<CurrentProfile>;
  isActive$: Observable<boolean>;

  constructor(
    private loginService: LoginService,
    private companyService: CompanyService,
    private currentProfileService: CurrentProfileService,
    private hamburgerMenuService: HamburgerMenuService,
    private routingService: RoutingService,
  ) {}

  ngOnInit(): void {
    this.currentProfile$ = this.currentProfileService.get();
    this.isActive$ = combineLatest({
      isExpanded: this.hamburgerMenuService.isExpanded,
      state: this.routingService.getRouterState().pipe(map((routerState: RouterState) => routerState.state)),
    }).pipe(
      map(
        ({ isExpanded, state }) =>
          !isExpanded && (state.url.includes('/my-account') || state.semanticRoute === 'login'),
      ),
    );
  }

  logout(): void {
    this.loginService.logout();
  }

  selectCompany(uid: string): void {
    this.companyService.selectCompany(uid);
  }

  resetSelectedCompany(): void {
    this.companyService.resetSelectedCompany();
  }
}
